module.exports = require('../lib/message')
